"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_calendar_1 = __importDefault(require("react-calendar"));
var react_jss_1 = require("react-jss");
var classnames_1 = __importDefault(require("classnames"));
require("react-calendar/dist/Calendar.css");
var useStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    datePicker: {
        fontFamily: 'inherit',
        '& button': {
            fontFamily: 'inherit',
        },
        '&.react-calendar': {
            minHeight: 260,
            minWidth: 250,
            border: 'none',
            padding: 6,
            background: theme.colors.Grey[0],
            borderRadius: theme.borderRadius.sm,
            boxShadow: '0px 1px 8px rgba(0, 0, 0, 0.1)',
        },
        '& .react-calendar__navigation': {
            background: theme.colors.Hannibal.default,
            borderRadius: theme.borderRadius.xs,
            marginBottom: '0.5em',
            '& button': {
                color: theme.colors.Grey[0],
                background: 'none !important',
            },
        },
        '& .react-calendar__month-view__weekdays__weekday': {
            color: theme.colors.Grey[500],
            fontWeight: 400,
            '& > abbr': {
                textDecoration: 'none',
                textTransform: 'capitalize',
            },
        },
        '& .react-calendar__month-view__days > button': {
            fontSize: 12,
            color: theme.colors.Grey[900],
            fontWeight: 400,
        },
        '& .react-calendar__tile:disabled': {
            backgroundColor: 'transparent',
            color: theme.colors.Grey[400],
        },
        '& .react-calendar__tile--now': {
            background: 'none',
        },
        '& .react-calendar__tile--active': {
            background: "".concat(theme.colors.Hannibal[100], " !important"),
            borderRadius: "".concat(theme.borderRadius.sm, " !important"),
            color: theme.colors.Hannibal.default,
        },
        '& .react-calendar__tile:enabled:hover': {
            background: theme.colors.Grey[100],
        },
    },
}); });
var Calendar = function (props) {
    var styles = useStyles();
    var className = props.className, rest = __rest(props, ["className"]);
    return (react_1.default.createElement(react_calendar_1.default, __assign({ className: (0, classnames_1.default)(styles.datePicker, className), next2Label: null, prev2Label: null }, rest)));
};
exports.default = Calendar;
//# sourceMappingURL=index.js.map